import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';

class SkipMainContent extends Component {

    handleScrollToTop () {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    render(){
        const { auth: {authorised}, i18n: { messages },isFAQ, onHide} = this.props;
        
        return(
          isFAQ?
            <div onBlur = {onHide} tabIndex={-1}> 
              {<a href='#faq-content' className='skip-to-faq' aria-hidden={true}>{messages['app.faq.viewFAQ']}</a> }         
            </div>
            :
            <div>
              {authorised &&  <a href="#main-content" onClick={this.handleScrollToTop} tabIndex={0} className='skip-to-content'>{messages['app.accessibility.skipmainContent']}</a> }         
            </div> 
          
        )
    }
}

export default createContainer({
    $queries: {
      auth: {
        authorised: true,
      },
      i18n: {
        messages: true,
      },
    }
})(SkipMainContent);

